module.exports = __webpack_public_path__ + "static/img/5bg_1.5ce405b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_1.png
// module id = 713
// module chunks = 1